var _style, _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRainStationInverted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 15 15",
    style: {
      enableBackground: "new 0 0 15 15"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;stroke:#000000;stroke-miterlimit:10;}\n\t.st1{stroke:#000000;stroke-miterlimit:10;}\n\t.st2{display:none;}\n\t.st3{display:inline;opacity:0.7;stroke:#000000;stroke-width:0.113;stroke-miterlimit:10;enable-background:new    ;}\n\t.st4{stroke:#000000;stroke-width:7.920000e-02;stroke-miterlimit:10;}\n\t.st5{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x35_52385_00000030471578822984344640000011881944484328379285_",
    transform: "matrix(0.0792 0 0 0.0792 8.4954 8.1834)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    className: "st0",
    d: "M74.4-10.6c0,48.5-38.9,87.8-86.9,87.8c-48,0-86.9-39.3-86.9-87.8 c0-48.5,38.9-87.8,86.9-87.8C35.5-98.4,74.4-59.1,74.4-10.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-12.6,77.7c-48.2,0-87.4-39.6-87.4-88.3s39.2-88.3,87.4-88.3c48.2,0,87.4,39.6,87.4,88.3 S35.6,77.7-12.6,77.7z M-12.6-97.9C-60.2-97.9-99-58.7-99-10.6s38.8,87.3,86.4,87.3c47.7,0,86.4-39.2,86.4-87.3 S35.1-97.9-12.6-97.9z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_58356",
    transform: "matrix(0.113 0 0 0.113 8.4925 7.9805)",
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    className: "st3",
    d: "M56.2-5.6c0,35.9-29.1,65-65,65c-35.9,0-65-29.1-65-65 c0-35.9,29.1-65,65-65C27.1-70.6,56.2-41.5,56.2-5.6z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "_x35_52385",
    transform: "matrix(0.0792 0 0 0.0792 8.4954 8.1834)"
  }, /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    className: "st4",
    d: "M57-10.6c0,38.8-31.1,70.2-69.6,70.2c-38.4,0-69.6-31.4-69.6-70.2 c0-38.8,31.1-70.2,69.6-70.2C25.8-80.8,57-49.4,57-10.6z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "_x35_59092",
    transform: "matrix(1 0 0 1 8.6414 8.8101)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-2,1.3h-0.7v-5.6h2.4c1.1,0,1.6,0.4,1.6,1.3l0,0c0,0.7-0.5,1.3-1.6,1.6l0,0l1.9,2.6h-1l-1.8-2.5v-0.5 c1.1-0.2,1.6-0.6,1.6-1.2l0,0c0-0.5-0.3-0.8-0.9-0.8l0,0H-2V1.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRainStationInverted);
export default __webpack_public_path__ + "static/media/Rain-Station-inverted.4359b3e9e0d2f9f6d8a3fedc0ec8e9f3.svg";
export { ForwardRef as ReactComponent };